module.exports = __webpack_public_path__ + "static/img/pingpai.d708360.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/aboutsUs/pingpai.png
// module id = bGtU
// module chunks = 1